export default (eventName, eventData) => {
    dataLayer.push({
        event: eventName,
        ...eventData
    });
};
